<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/banner.jpg"
    ></landingBanner>
    <newform></newform>
    <div style="width:100%;padding:15px 0;">
        <router-link to="chat">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newcake/6000.jpg"
        to="chat"
      />
      </router-link>
    </div>
    <h2 style="text-align:center;padding:10px 0;">学员作品</h2>
    <van-swipe :autoplay="3000" indicator-color="#fff">
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part2-1.jpg"
        />
      </van-swipe-item>
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part2-2.jpg"
        />
      </van-swipe-item>
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part2-3.jpg"
        />
      </van-swipe-item>
    </van-swipe>
    <div style="width:100%;height:10px;"></div>
    <div style="padding:0 10px;">
      <van-button
        color="#e65c2d"
        style="width:100%;font-size:17px;font-weight:600;"
        to="chat"
      >点击了解课程学费</van-button>
    </div>
    <div style="width:100%;height:15px;"></div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <h2 style="text-align:center;padding:10px 0;">教学环境</h2>
    <van-swipe :autoplay="3000" indicator-color="#fff">
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part1-1.jpg"
        />
      </van-swipe-item>
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part1-2.jpg"
        />
      </van-swipe-item>
      <van-swipe-item>
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part1-3.jpg"
        />
      </van-swipe-item>
    </van-swipe>
    <div style="width:100%;height:15px;"></div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <h2 style="text-align:center;padding:10px 0;">更多热门课程推荐</h2>
    <div style="padding:10px;background: #e65c2d;">
      <div class="more">
        <div class="more-1">
          <img
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fatan/part4.jpg"
            style="width:100%;height:90px"
          />
        </div>
        <div class="more-2">
          <h2 style="color:#fff">烘焙甜点经典班</h2>
          <div class="more-2-words">BAKING DESSERT ELITE CLASS</div>
          <div style="width:100%;height:7px"></div>
          <router-link to="/baking3">
            <el-button type="warning" plain size="small" style="margin-right:10px;">专业介绍</el-button>
          </router-link>
          <router-link to="chat">
            <el-button type="warning" size="small">查看学费</el-button>
          </router-link>
        </div>
      </div>
    </div>
    <div style="width:100%;height:15px;"></div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <newform></newform>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("@/components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    find2: () => import("@/components/common/find2"),
    newform: () => import("@/components/form/newform")
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.content {
  padding: 10px;
}
.more {
  width: 100%;
  height: 110px;
//   border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.more-1 {
  width: 45%;
  height: 90px;
  margin-right: 10px;
  float: left;
}
.more-2 {
  height: 90px;
  float: left;
}
.more-2-words {
  font-size: 13px;
  color: #fff;
}
</style>